import React, { FC, isValidElement, ReactNode } from "react";
import classNames from "classnames";
import { ScanPageItemEnum, ScanPageBodyProps, ScanPageBodyItemEnum } from "../interface";

const Header: FC<ScanPageBodyProps> = props => {
  const { children, className, style, } = props;
  // const renderChildren = (childrenNodes: ReactNode): ReactNode => {
  //   return React.Children.map(childrenNodes, child => {
  //     const childElement = child as React.FunctionComponentElement<ScanPageBodyProps>;
  //     if (!isValidElement(childElement)) return null;
  //     if (!childElement.type) return null;
  //     const { displayName } = childElement.type;
  //     if (displayName && displayName in ScanPageBodyItemEnum) {
  //       return React.cloneElement(childElement);
  //     } else {
  //       console.error(
  //         'Warning: ScanPageRight has a child which is not a Left and Content or Right component',
  //       );
  //     }
  //   });
  // };
  const classes = classNames('scan-page-body', className);
  return (
    <div className={classes} style={style}>{children}</div>
  );
};

Header.displayName = ScanPageItemEnum.Header;

export default Header;